export default __webpack_public_path__ + "static/media/323-mark.4ea81762.svg";